<app-header></app-header>
<app-page-title></app-page-title>

<div class="page-container">

  <!-- Page content -->
  <div class="page-content">

    <!-- Main content -->
    <div class="content-wrapper">

      <div class="row">

        <app-industry-list></app-industry-list>

      </div>

    </div>
  </div>
</div>

<app-footer></app-footer>
